import React, { useState, useReducer, useEffect, useContext } from "react";
import { Alert, Card, Col, Row, Table, Badge, Image } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { BreadcrumbContext } from "../../../contexts/BreadcrumbContext";
import queryString from "query-string";
import moduleConfig from "./moduleConfig";
import axios from "../../../config/axios";
import { Store as toast } from "react-notifications-component";
import { toastNotification } from "../../../config/toastNotification";
import DashboardLayout from "../../UI/layouts/DashboardLayout";
import { ContainerLoading } from "../../UI/loading/ContainerLoading";
import BlockErrorMessage from "../../UI/errorMessages/BlockErrorMessage";
import ModuleHeader from "../../UI/modules/views/partials/common/ModuleHeader";
import FormErrorMessage from "../../UI/errorMessages/FormErrorMessage";
import useConfirm from "../../../HOC/custom/useConfirm";
import ListingFooter from "./partials/listing/ListingFooter";
import SearchArea from "./partials/listing/SearchArea";
import Item from "./partials/listing/Item";
import { listingReducer, listingInitialState } from "../../../reducers/module/listingReducer";
import { OverlayLoading } from "../../UI/loading/OverlayLoading";
import { loadItemsGeneral, resetFiltersGeneral, setFilterGeneral } from "../../../helpers/ModuleHelperFunctions";

const CustomerListing = () => {
  const { setBreadcrumb } = useContext(BreadcrumbContext);
  const [listingState, listingDispatch] = useReducer(
    listingReducer,
    listingInitialState
  );
  const { search } = useLocation();
  const [appliedFilters, setAppliedFilters] = useState(
    queryString.parse(search)
  );
  if (appliedFilters.limit) {
    moduleConfig.perPageItems = appliedFilters.limit;
  }

  let history = useNavigate();

  const setFilter = (name, value) => {
    setFilterGeneral(name, value,appliedFilters,setAppliedFilters,history)
  }

  const resetFilters = () => {
    resetFiltersGeneral(appliedFilters,setAppliedFilters,history, moduleConfig);
  };

  useEffect(() => {
     loadItemsGeneral(listingDispatch,moduleConfig.url,search);
  }, [search]);

  useEffect(() => {
    setBreadcrumb([moduleConfig.breadcrumbs.listing]);
  }, []);


  return (
    <DashboardLayout>
      {listingState.isLoading && <OverlayLoading />}

      {listingState.status !== "fetching" && (
        <>
          {listingState.error && listingState.status === "fetchFailed" ? (
            <BlockErrorMessage error={listingState.error} />
          ) : (
            <>
              <ModuleHeader
                moduleTitle={moduleConfig.title}
                moduleUrl={moduleConfig.url}
              >
                
              </ModuleHeader>

              <div className="listingPage">
                {listingState.data &&
                listingState.data.pagination &&
                listingState.data.pagination.totalItems > 0 ? (
                  <>
                    {/* Search Area */}
                    <SearchArea
                      moduleConfig={moduleConfig}
                      setFilter={setFilter}
                      appliedFilters={appliedFilters}
                      resetFilters={resetFilters}
                    />

                    {/* Listing */}
                    <section className="content listing ">
                      {listingState.error && (
                        <FormErrorMessage error={listingState.error} />
                      )}

                      {!listingState.data.items ||
                      listingState.data.items.length <= 0 ? (
                        <Alert className="alert-custom-1">
                          No records found with selected filters.{" "}
                          <Alert.Link
                            href="#"
                            className="text-custom-3"
                            onClick={() => resetFilters()}
                          >
                            <i className="fas fa-times text-custom-3" /> Reset
                            Filters
                          </Alert.Link>
                          .
                        </Alert>
                      ) : (
                        <>
                          {listingState.data.items &&
                            listingState.data.items.length && (
                              <>
                                {listingState.data.items.map(
                                  (item, itemIndex) => {
                                    return (
                                      <Col>
                                        <Item
                                          moduleConfig={moduleConfig}
                                          item={item}
                                        />
                                      </Col>
                                    );
                                  }
                                )}
                              </>
                            )}
                        </>
                      )}
                    </section>

                    <ListingFooter
                      listingState={listingState}
                      moduleConfig={moduleConfig}
                      setFilter={setFilter}
                    />
                  </>
                ) : (
                  <Alert className="alert-custom-1">No records found.</Alert>
                )}
              </div>
            </>
          )}
        </>
      )}
    </DashboardLayout>
  );
};

export default CustomerListing;
